module.exports = __webpack_public_path__ + "img/code.f13d4b67.png";